<template>
  <div>
    <v-row>
      <v-col>
        <h2 v-if="booking.vehicle.type.toLowerCase().includes('truck')" class="primary--text"> <span class="warning--text">TRUCK</span> available</h2>
        <h2 v-else class="primary--text"><span class="warning--text">{{booking.status.type}}</span> Booking available</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Booking number</h3></v-col>
      <v-col><h3>{{ booking.orderNumber.number }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Date and time</h3></v-col>
      <v-col><h3>{{ booking.preferredDate }} &nbsp; {{ booking.preferredTime === 'AM' ? 'AM' : 'PM' }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Address</h3></v-col>
      <v-col><h3>{{ booking.capturedAddress }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Company</h3></v-col>
      <v-col> <h3>{{ booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName + " " + booking.customer.lastName }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Customer</h3></v-col>
      <v-col> <h3>{{ booking.customer.firstName + " " + booking.customer.lastName }}</h3></v-col>
    </v-row>
    <v-row v-if="booking.instructions">
      <v-col md="3"><h3 class="warning--text">Instructions</h3></v-col>
      <v-col class="warning--text"><h3>{{ booking.instructions }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text">Waste type</h3>
      </v-col>
      <v-col>
        <h3>{{ booking.waste.name }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text">Vehicle type</h3>
      </v-col>
      <v-col>
        <h3>{{ booking.vehicle.name }}</h3>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col>
        <h2 v-if="this.booking.vehicle.type.toLowerCase().includes('truck')" class="primary--text"> Preferred date and time for collection: </h2>
        <h2 v-else class="primary--text"> Preferred date and time for {{booking.status.type.toLowerCase()}}: </h2>
      </v-col>
    </v-row>
    <v-row>
       <v-col md="3">
        <v-menu
            ref="datePicker"
            v-model="datePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateFormatted"
                label="Date"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              no-title
              :min="minDate"
              @input="datePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3">
        <v-select
            label="Time"
            :items="preferredTimes"
            v-model="preferredTime"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row justify="end" class="mr-1">
          <v-btn v-on:click="changeStatus" class="primary"> Schedule Order </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <br/>
  </div>
</template>

<script>

export default {
  name: 'DriverPickup',
  props: {
    booking: Object
  },
  data (){
    return {
      minDate: new Date().toISOString().substr(0, 10),
      preferredTime: undefined,
      preferredTimes: [ 'AM', 'PM' ],
      date: undefined,
      dateFormatted: undefined,
      datePicker: false
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async changeStatus() {
      if (this.date && this.preferredTime){
        await this.$store.dispatch('updateBooking', {
          id: this.booking.id,
          driver: {
            ...this.driver,
            lat: this.location.lat,
            long: this.location.long
          },
          status: {
            ...this.booking.status,
            status: 'SCHEDULED'
          },
          preferredDate: this.date,
          preferredTime: this.preferredTime
        });
      } else {
        await this.$store.dispatch('updateBooking', {
          id: this.booking.id,
          driver: {
            ...this.driver,
            lat: this.location.lat,
            long: this.location.long
          },
          status: {
            ...this.booking.status,
            status: 'SCHEDULED'
          }
        });
      }
    }
  },
  computed: {
    driver() {
      return this.$store.getters['auth/getUser'];
    },
    location(){
      let driverLocation = this.$store.getters['driver/getLocation'];
      driverLocation.lat = driverLocation.lat ? driverLocation.lat : "";
      driverLocation.long = driverLocation.long ? driverLocation.long : "";
      return driverLocation;
    }
  },
  mounted(){
    //get current driver location and add to users database
    if (navigator.geolocation){
        navigator.geolocation.getCurrentPosition((position) => {
          this.$store.dispatch('driver/updateDriver', {
            id: this.driver.id,
            lat: position.coords.latitude,
            long: position.coords.longitude
          })
        })
      }
      else{
        alert('Please enable location');
      }
  }
}
</script>

<style scoped>

</style>